import { buildService } from './decorated-service';
import {
  StaticJointApplication,
  OptionalStaticJointApplication,
  JointApplication
} from '../../../core/types/applications/taxable-applications/joint-application';
import {
  handleSubmissionError,
  purgeEmptyFields,
  removeExtraAddressFields,
  submissionTimeOutErrorCode
} from './util';
import { consumerTypes } from '../utils';
import { setBenesBasedOnStateResidence } from '../../taxable-flows/shared/util';

const JointSubmissionApi = buildService(
  '/new-account-svc/service/v2/account/joint'
);

const FONASUJointSubmissionApi = buildService(
  '/new-account-svc/service/front-office/v2/account/joint'
);

export const JointApplicationService = (
  args: OptionalStaticJointApplication,
  consumerName
): Promise<any> => {
  const validated: StaticJointApplication = JointApplication.check(args);
  // last bastion of defense against TOD creation for LA residents
  const payload = setBenesBasedOnStateResidence(validated);
  const submissionPayload = purgeEmptyFields(payload);
  const finalSubmissionPayload = removeExtraAddressFields(submissionPayload);

  const apiEndpoint =
    consumerName === consumerTypes.FONASU
      ? FONASUJointSubmissionApi
      : JointSubmissionApi;

  return apiEndpoint.add(finalSubmissionPayload, {
    submissionTimeOutErrorCode,
    handleServiceResponse: handleSubmissionError
  });
};
